import React, { useState } from 'react';
import '../styles/TaskForm.css';

// Composant formulaire pour créer une nouvelle tâche
function TaskForm({ cats, onAddTask }) {
  // Champs du formulaire
  const [title, setTitle] = useState(''); // Titre de la tâche
  const [description, setDescription] = useState(''); // Description
  const [prio, setPrio] = useState('medium'); // Priorité (low/medium/high)
  const [selCats, setSelCats] = useState([]); // Catégories sélectionnées (IDs)
  const [date, setDate] = useState(''); // Date d'échéance

  // Soumission du formulaire
  const handleSubmit = (e) => {
    e.preventDefault();
    // Vérifie qu'au moins une catégorie est sélectionnée
    if(selCats.length === 0) return alert("Choisissez au moins une catégorie");
    
    // Envoie les données au composant parent (Dashboard)
    onAddTask({ title, description, priority: prio, category_ids: selCats, due_date: date, status: 'pending' });
    
    // Réinitialise le formulaire
    setTitle(''); setDescription(''); setSelCats([]);
  };

  // Ajoute ou retire une catégorie de la sélection
  const toggleCat = (id) => {
    selCats.includes(id) ? setSelCats(selCats.filter(c=>c!==id)) : setSelCats([...selCats, id]);
  };

  return (
    <div className="box">
      <h3>Nouvelle Tâche</h3>
      <form onSubmit={handleSubmit}>
        <input placeholder="Titre..." value={title} onChange={e=>setTitle(e.target.value)} required />
        <textarea className="task-description" placeholder="Description..." value={description} onChange={e=>setDescription(e.target.value)} rows="3"></textarea>
        
        <div className="form-row">
          <div className="form-field">
            <label>Date</label>
            <input type="date" value={date} onChange={e=>setDate(e.target.value)} />
          </div>
          <div className="form-field">
            <label>Priorité</label>
            <select value={prio} onChange={e=>setPrio(e.target.value)}>
              <option value="low">Basse</option>
              <option value="medium">Moyenne</option>
              <option value="high">Haute</option>
            </select>
          </div>
        </div>
        
        <div className="category-selector-container">
          <small>Sélectionnez les catégories :</small>
          <div className="category-selector">
            {cats.map(c => (
              <div
                key={c.id}
                className={`category-chip ${selCats.includes(c.id) ? 'selected' : ''}`}
                style={{ background: c.color }}
                onClick={() => toggleCat(c.id)}
              >
                {c.name}
              </div>
            ))}
          </div>
        </div>
        <button type="submit">Ajouter une Tâche</button>
      </form>
    </div>
  );
}

export default TaskForm;